/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

'use client';

import { useState } from 'react';
import {
  Container, Row, Col, Card, CardBody,
} from 'reactstrap';
import Link from 'next/link';
import Image from 'next/image';

// Import Icons
import FeatherIcon from 'feather-icons-react';

// Fade in effect
// import FadeIn from 'react-fade-in';

// Import Images
import datePickerBg from '../../assets/images/shop/datePicker_bg.webp';
import buttonsBg from '../../assets/images/shop/buttons_bg.webp';
import controls3D from '../../assets/images/shop/3dControl_bg.webp';
import radarBg from '../../assets/images/shop/radar_bg.webp';
import polarBg from '../../assets/images/shop/polar_bg.webp';
import pieBg from '../../assets/images/shop/pie_bg.webp';
import lineBarBg from '../../assets/images/shop/line-bar-bg.webp';
import widgetLibraryBg from '../../assets/images/shop/widget-library-bg.webp';

const marginStyle = {
  scrollMarginTop: '80px',
};

const works = [
  // {
  //   id: 1,
  //   image: work1,
  //   title: 'Industrial widgets',
  //   subtitle: 'widget',
  //   category: 'widgets',
  //   link: '/shop-product-detail/2',
  // },
  {
    id: 2,
    image: buttonsBg,
    title: 'Material Design Buttons',
    subtitle: 'widget',
    category: 'widgets',
    link: '/shop/material-design-buttons',
  },
  {
    id: 3,
    image: widgetLibraryBg,
    title: 'HMI Widget Library SVG/SVGHMI',
    subtitle: 'widget',
    category: 'widgets',
    link: '/shop/hmi-industrial-widget-library',
  },
  {
    id: 4,
    image: datePickerBg,
    title: 'Date Picker',
    subtitle: 'component',
    category: 'components',
    link: '/shop/date-picker-component',
  },
  {
    id: 5,
    image: controls3D,
    title: 'WinCC 3D Controls',
    subtitle: 'component',
    category: 'components',
    link: '/shop/wincc-unified-3d-control',
  },
  {
    id: 6,
    image: lineBarBg,
    title: 'Line&Bar Chart Controls',
    subtitle: 'component',
    category: 'components',
    link: '/shop/line-bar-chart-control',
  },
  {
    id: 7,
    image: radarBg,
    title: 'Radar Chart Controls',
    subtitle: 'component',
    category: 'components',
    link: '/shop/radar-chart-web-control',
  },
  {
    id: 8,
    image: polarBg,
    title: 'Polar Chart Controls',
    subtitle: 'component',
    category: 'components',
    link: '/shop/polar-chart-web-control',
  },
  {
    id: 9,
    image: pieBg,
    title: 'Pie&Doughnut Chart Controls',
    subtitle: 'component',
    category: 'components',
    link: '/shop/pie-doughnut-chart',
  },
  // {
  //   image: work4,
  //   title: 'Yellow bg with Books',
  //   subtitle: 'Company V-card',
  //   category: 'Buildings',
  // },
  // {
  //   image: work5,
  //   title: 'Company V-card',
  //   subtitle: 'V-card',
  //   category: 'Roads',
  // },
  // {
  //   image: work6,
  //   title: 'Mockup box with paints',
  //   subtitle: 'Photography',
  //   category: 'Offices',
  // },
];

function ShopOffer() {
  const [displayCategory, setDisplayCategory] = useState('All');

  return (
    <>
      {/* breadcrumb */}
      <Container className="mt-100 mt-60" id="shop-section" style={marginStyle}>
        <Row>
          <Col lg={4} md={6}>
            <div className="section-title sticky-bar position-sticky">
              <span className="badge rounded-pill bg-soft-primary">
                shop
              </span>
              <h4 className="title mt-3 mb-4">
                Our latest components
              </h4>
              <p className="text-muted para-desc mb-0">
                Start working with
                {' '}
                <span className="text-primary fw-bold">
                  SVGHMI.pro
                </span>
                {' '}
                graphics and components
                that can provide everything you need to generate magnificent and
                useful HMIs.
              </p>
              <div className="mt-4 d-none d-md-block">
                <Link href="/shop/?filter=all&page=1" className="btn btn-soft-primary">
                  See More
                  {' '}
                  <i>
                    <FeatherIcon icon="arrow-right" className="fea icon-sm" />
                  </i>
                </Link>
              </div>
            </div>
          </Col>
          <Col lg={8} md={6} className="mt-4 pt-2 mt-sm-0 pt-sm-0">
            <Row>
              <div className="col-12 filters-group-wrap">
                <div className="filters-group">
                  <ul
                    className="container-filter list-inline mb-0 filter-options"
                    id="filter"
                  >
                    <li
                      onClick={() => setDisplayCategory('All')}
                      className={
                        displayCategory === 'All'
                          ? 'list-inline-item categories-name border text-dark rounded active'
                          : 'list-inline-item categories-name border text-dark rounded '
                      }
                    >
                      All
                    </li>
                    {' '}
                    <li
                      onClick={() => setDisplayCategory('widgets')}
                      className={
                        displayCategory === 'widgets'
                          ? 'list-inline-item categories-name border text-dark rounded active'
                          : 'list-inline-item categories-name border text-dark rounded'
                      }
                    >
                      Widgets
                    </li>
                    {' '}
                    <li
                      onClick={() => (setDisplayCategory('components'))}
                      className={
                        displayCategory === 'components'
                          ? 'list-inline-item categories-name border text-dark rounded active'
                          : 'list-inline-item categories-name border text-dark rounded'
                      }
                    >
                      Components
                    </li>
                    {' '}
                    <li
                      onClick={() => setDisplayCategory('JS Snippets')}
                      className={
                        displayCategory === 'JS Snippets'
                          ? 'list-inline-item categories-name border text-dark rounded active'
                          : 'list-inline-item categories-name border text-dark rounded'
                      }
                    >
                      {' '}
                      JS Snippets
                    </li>
                  </ul>
                </div>
              </div>
            </Row>

            <Row className="projects-wrapper">
              {works
                .filter(
                  ({ category }) => displayCategory === category
                      || displayCategory === 'All',
                )
                .map(({
                  title, image, subtitle, id, link,
                }) => (
                  <Col
                    key={id}
                    lg={6}
                    xs={12}
                    md={6}
                    className="mt-4 pt-2 offices"
                  >
                    {/* <FadeIn delay={100}> */}
                    <Card className="border-0 work-container work-classic shadow overflow-hidden">
                      <CardBody className="p-0">
                        <Link href={link}>
                          <Image
                            src={image.src}
                            className="img-fluid work-image"
                            alt="SVGHMI.pro"
                            width={360}
                            height={238}
                          />
                        </Link>
                        <div className="content p-4">
                          <h5 className="mb-0">
                            <Link
                              href={link}
                              className="text-dark title"
                            >
                              {title}
                            </Link>
                          </h5>
                          <h6 className="text-muted tag mb-0">
                            {subtitle}
                          </h6>
                        </div>
                      </CardBody>
                    </Card>
                    {/* </FadeIn> */}
                  </Col>
                ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ShopOffer;
